import {
  LayoutDashboard,
  Users,
  MailQuestion,
  Info,
  FileText,
  Layers,
  MessageSquare,
  LayoutGrid,
  Database,
  Menu,
  Tag,
  Shield,
  UserCog,
  Mail,
} from "lucide-react";
import StatsGrid from "./statsGrid";
import SubmissionsTable from "./submissionTable";
import InquiriesPage from "../InquiryPage";
import InformationPage from "../InformationPage";
import ContentPagesManager from "../ContentPagesManager";
import PageSectionsManager from "../PageSectionsManager";
import {
  TestimonialManager,
  ServiceCardManager,
  ContentBlockManager,
  NavigationItemManager,
  TagManager,
  RoleManager,
  AdminUserManager,
  EmailTemplateManager,
} from "../modals";


export const TAB_CONFIG = {
  dashboard: {
    label: "Dashboard",
    description: "System Analytics & Recent Submissions",
    icon: LayoutDashboard,
    component: (props) => (
      <div className="space-y-10">
        <StatsGrid submissions={props.submissions} />
        <div className="bg-white rounded-[2.5rem] shadow-xl shadow-slate-200/60 border border-slate-100 overflow-hidden">
          <div className="p-8 border-b border-slate-50 flex justify-between items-center">
            <h2 className="text-lg font-black text-slate-900">
              Recent Applications
            </h2>
          </div>
          <SubmissionsTable {...props} />
        </div>
      </div>
    ),
  },
  inquiries: {
    label: "Customer Inquiries",
    description: "Manage and respond to direct messages",
    icon: MailQuestion,
    component: () => <InquiriesPage />,
  },
  submissions: {
    label: "Database",
    description: "Complete list of candidate applications",
    component: (props) => (
      <div className="bg-white rounded-[2.5rem] shadow-xl border border-slate-100 overflow-hidden">
        <SubmissionsTable
          submissions={props.submissions}
          onDelete={props.onDelete}
          pagination={props.pagination}
          onPageChange={(newPage) => props.refreshData(newPage)}
        />
      </div>
    ),
  },
  info: {
    label: "Information",
    description: "Manage company details and contact information",
    icon: Info,
    component: () => <InformationPage />,
  },
  "content-pages": {
    label: "Content Pages",
    description:
      "Edit Privacy Policy, Terms of Service, and Cookie Policy (EN / JA)",
    icon: FileText,
    component: () => <ContentPagesManager />,
  },
  "page-sections": {
    label: "Page Sections",
    description: "Control page layout, section order, visibility, and header content",
    icon: Layers,
    component: () => <PageSectionsManager />,
  },
  testimonials: {
    label: "Testimonials",
    description: "Manage client testimonials shown on the website",
    icon: MessageSquare,
    component: () => <TestimonialManager />,
  },
  "service-cards": {
    label: "Service Cards",
    description: "Manage the services and benefits cards",
    icon: LayoutGrid,
    component: () => <ServiceCardManager />,
  },
  "content-blocks": {
    label: "Content Blocks",
    description: "Manage content blocks for page sections",
    icon: Database,
    component: () => <ContentBlockManager />,
  },
  "navigation-items": {
    label: "Navigation Items",
    description: "Manage navbar and footer navigation links",
    icon: Menu,
    component: () => <NavigationItemManager />,
  },
  tags: {
    label: "Manage Tags",
    description: "Create and manage application tags",
    icon: Tag,
    component: () => <TagManager />,
  },
  roles: {
    label: "Manage Roles",
    description: "Create and manage system roles and access levels",
    icon: Shield,
    component: () => <RoleManager />,
  },
  users: {
    label: "Admin Users",
    description: "Manage admin user accounts and their roles",
    icon: UserCog,
    component: () => <AdminUserManager />,
  },
  emails: {
    label: "Email Templates",
    description: "Create and manage transactional email templates",
    icon: Mail,
    component: () => <EmailTemplateManager />,
  },
};
